<template>
    <v-card width="auto" tile>
        <v-form ref="form">
            <v-card-text>
                <v-row dense>
                    <v-col cols="12" sm="5" md="3">
                        <v-text-field
                            v-model="model.clave"
                            label="Clave"
                            outlined
                            :rules="fieldRequired"
                            dense>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="5" md="9">
                        <v-text-field
                            v-model="model.nombre"
                            label="Nombre"
                            outlined
                            :rules="fieldRequired"
                            dense>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2" md="4" v-if="get_dialogMain.type == 'update'">
                        <v-sheet width="100%" height="100%" class="pa-1">
                            <v-switch
                            v-model="model.activo"
                            label="Activo"
                            :value="model.activo"
                            flat/>
                        </v-sheet>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-layout justify-end>
                <v-btn class="red darken-1 mr-3" dark @click="onCancel">Cancelar</v-btn>
                <v-btn class="green darken-1 mr-3" dark @click="save"> Guardar</v-btn>
                </v-layout>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: ['model', 'onSuccess', 'onCancel'],
  data: () => ({
    fieldRequired: [
      value => !!value || 'Campo Requerido.'
    ]
  }),
  methods: {
    save () {
      if (this.$refs.form.validate()) {
        this.onSuccess(this.model)
      } else {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'ERROR',
          text: 'Hay campos obligatorios'
        })
      }
    }
  },
  computed: {
    ...mapGetters(['get_dialogMain'])
  }
}
</script>

<style>

</style>
